import * as yup from 'yup';

import {
  checkParanthesisBalanced,
  checkQuotesBalanced,
  getKeywords,
  hasParanthesis,
} from './helpers';

export const validateParanthesis = async (input: string | null | undefined) => {
  if (!input || !hasParanthesis(input)) return true;

  return await checkParanthesisBalanced(input);
};

const yupValidateParanthesis: yup.TestFunction<
  string | null | undefined,
  object
> = async (input) => {
  return validateParanthesis(input);
};

export const validateBooleanOperators = (input: string | null | undefined) => {
  if (!input) return true;
  const keywords = getKeywords(input);

  return keywords.every(Boolean);
};

const yupValidateBooleanOperators: yup.TestFunction<
  string | null | undefined,
  object
> = (input) => {
  return validateBooleanOperators(input);
};

export const validateQuotesBalancing = async (
  input: string | null | undefined
) => {
  if (!input) return true;
  const keywords = getKeywords(input);

  const quoteBalancedResults = await Promise.all(
    keywords.map(checkQuotesBalanced)
  );
  return quoteBalancedResults.every(Boolean);
};

const yupValidateQuotesBalancing: yup.TestFunction<
  string | null | undefined,
  object
> = (input) => {
  return validateQuotesBalancing(input);
};

export const validateKeyword = async (input: string | null | undefined) => {
  if (!input) return true;

  const isValidParanthesis = await validateParanthesis(input);
  if (!isValidParanthesis) return false;

  const keywords = getKeywords(input);

  const isUnusedBooleanOperators = !keywords.every(Boolean);
  if (isUnusedBooleanOperators) return false;

  const quoteBalancedResults = await Promise.all(
    keywords.map(checkQuotesBalanced)
  );
  const isQuotesBalanced = quoteBalancedResults.every(Boolean);
  if (!isQuotesBalanced) return false;

  return true;
};

export const keywordSchema = yup
  .string()
  .nullable()
  .optional()
  .test(
    'is-paranthesis-balanced',
    'Invalid keyword. Paranthesis are imbalanced.',
    yupValidateParanthesis
  )
  .test(
    'is-valid',
    'Invalid keyword. Unused Boolean Operators at ends.',
    yupValidateBooleanOperators
  )
  .test(
    'is-quotes-balanced',
    'Invalid keyword. Quotes are either imbalanced or not at ends.',
    yupValidateQuotesBalancing
  );
